import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useUserStore } from "@/stores/userStore";
import { estatePlan } from "../utils/commonSvg";
/**
 * Composable for managing navigation menu items
 * Eliminates code duplication between BottomNav.vue and LeftSidebar.vue
 */
export function useNavigationMenu(rightPanelStore) {
  const { t, locale } = useI18n();
  const userStore = useUserStore();

  // Path mapping for modules
  const PATH_MAPPING = {
    estate: "/my-estate-plan",
    digital_vault: "/digital-vault",
    legacy: "/legacy",
    documents: "/documents",
  };

  // Build menu items from module data with reactive translations
  const menuItems = computed(() => {
    // Dependencies: moduleData and locale to ensure reactivity
    const moduleData = rightPanelStore.moduleData;
    const currentLocale = locale.value;

    if (!Array.isArray(moduleData)) {
      console.warn("Invalid module data:", moduleData);
      return [];
    }

    const items = moduleData
      .filter((module) => module.hasAccess === "yes")
      .sort((a, b) => a.moduleOrder - b.moduleOrder)
      .map((module) => ({
        id: module.moduleSlug,
        label: t(module.name),
        icon: module.icon,
        path: PATH_MAPPING[module.moduleSlug] || `/${module.moduleSlug}`,
      }));

    const hasDigitalVault = userStore.licensesName?.includes("digital_vault");
    if (hasDigitalVault) {
      items.push({
        id: "account-agent",
        label: t("commonLabels.accountAgent"),
        icon: estatePlan,
        path: "/account-agent",
      });
    }

    return items;
  });

  return {
    menuItems,
  };
}
